export interface AddressFormValues {
    lineOne: string;
    lineTwo: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
}
